export default "__VITE_ASSET__DAzr1eFL__"